import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { getUtm } from 'widget/actions';
import { useUrl } from 'widget/hooks';
import * as Env from 'widget/env';

const useRequest = () => {
  const { API_URL } = useUrl();

  const instance = useMemo(
    () =>
      axios.create({
        baseURL: API_URL,
        headers: { 'Content-Type': 'application/json' },
      }),
    [],
  );

  const handleThen = (res: AxiosResponse) => {
    const { data } = res;

    if (data.success == false) return null;
    return data.data;
  };

  const request = async <T>(
    url: string,
    config: AxiosRequestConfig,
  ): Promise<T | null> => {
    const res = await instance(url, config)
      .then(handleThen)
      .catch(() => null);

    return res;
  };

  const fetchDialogsRead = (xChatToken: string, dialog_id: string) =>
    request(`v1/dialogs/${dialog_id}/read`, {
      headers: { 'X-Chat-Token': xChatToken },
    });

  interface PostAuthRegister {
    access_token: string;
    user_id: string;
  }

  const postAuthRegister = (
    chat_id: string,
    { email, name, phone }: Partial<Env.Guest> = {},
  ) => {
    const utm = getUtm();

    return request<PostAuthRegister>('auth/register', {
      data: {
        chat_id,
        domain: window.location.origin,
        email,
        name: name || `Guest ${uuid().split('-')[0]}`,
        phone,
        referer: document.referrer,
        role: 'guest',
        user_agent: navigator.userAgent,
        utm,
      },
      method: 'post',
    });
  };

  return { fetchDialogsRead, postAuthRegister };
};

export default useRequest;
